module.exports = __webpack_public_path__ + "assets/img/img320.7a7dab69.png";